/**
 * When backspace is pressed, if the current line is blank and has a type
 * passed to the `blocks` array, it will be reset to the `defaultBlock` type.
 */
export default ({ blocks = [], defaultBlock = "paragraph" }) => ({
  onKeyDown(event, editor, next) {
    if (event.key == "Backspace") {
      const startBlock = editor.value.startBlock
      if (startBlock.text !== "") {
        return next()
      }
      if (!blocks.includes(startBlock.type)) return next()

      event.preventDefault()
      editor.setBlocks(defaultBlock)
    } else {
      return next()
    }
  }
})
